import { css } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const defaultPrimaryAppearance = css `
  color: ${theme.semantic.foreground.secondary};
  border-color: ${theme.semantic.border.default};
  background-color: ${theme.semantic.action.secondary.default};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.tertiary};
  }

  &:disabled {
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      [data-icon='falcon'] {
        color: ${theme.semantic.foreground.primary};
      }

      color: ${theme.semantic.foreground.primary};
      border-color: ${theme.swatches.warm[1000]};
      background-color: ${theme.semantic.action.secondary.active};
    }

    &:active {
      background-color: ${theme.semantic.action.secondary.active};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(4)} ${theme.semantic.focus.ring};
    }
  }
`;
const toggledPrimaryAppearance = css `
  color: ${theme.semantic.foreground.primary};
  border-color: ${theme.swatches.warm[1000]};
  background-color: ${theme.semantic.action.secondary.hover};

  [data-icon='falcon'] {
    color: ${theme.semantic.foreground.primary};
  }

  &:disabled {
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${theme.semantic.action.secondary.default};
    }

    &:active {
      background-color: ${theme.semantic.action.secondary.active};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(4)} ${theme.semantic.focus.ring};
    }
  }
`;
export const getToggleButtonAppearance = (appearance, toggled) => {
    if (toggled) {
        switch (appearance) {
            case 'primary':
            default:
                return toggledPrimaryAppearance;
        }
    }
    switch (appearance) {
        case 'primary':
        default:
            return defaultPrimaryAppearance;
    }
};
